import { X } from "lucide-react";
import { useState } from "react";
import { cn } from "../../Utils/Utils";

function ConfirmationModal({
	title = "Confirmation",
	description = "",
	yesButtonText = "Confirm",
	cancelButtonText = "Cancel",
	isCopy = false,
	handleClose = () => {},
	yesFunc = async () => {},
	onClose,
}: {
	title: string;
	description: string;
	yesButtonText?: string;
	cancelButtonText?: string;
	handleClose: () => void;
	yesFunc: () => Promise<void>;
	onClose: () => void;
	isCopy?: boolean;
}) {
	const [loading, setLoading] = useState<boolean>(false);
	const handleConfirm = async () => {
		setLoading(true);
		await yesFunc();
		setLoading(false);
		isCopy ? onClose() : handleClose();
	};
	return (
		<div
			className='absolute z-50 top-0 left-0 bg-black/30 h-screen w-screen flex flex-row justify-center items-center visible'
			onClick={handleClose}
		>
			<div
				className='w-[90vw] lg:w-[35vw]  min-h-fit bg-white rounded-2xl p-6'
				onClick={(e) => e.stopPropagation()}
			>
				<div className='flex flex-row justify-between items-center pb-3'>
					<h1 className='font-medium text-2xl lg:text-3xl text-themeColor '>
						{title}
					</h1>
					<button
						className='text-gray-500 hover:text-black duration-200 w-fit h-fit hover:bg-slate-100 rounded-full p-0.5'
						onClick={onClose}
					>
						<X />
					</button>
				</div>
				<p className='text-gray-500 text-base'>{description}</p>
				<div className='flex flex-row justify-end items-center gap-x-2 mt-6'>
					<button
						className='border-[1.5px] border-themeColor rounded-lg text-sm sm:text-base p-2 px-4 text-themeColor bg-themeColor/10 hover:bg-themeColor/20 duration-200 overflow-hidden'
						onClick={handleClose}
					>
						{cancelButtonText}
					</button>
					<button
						className={cn(
							"border-[1.5px] border-themeColor rounded-lg text-sm sm:text-base p-2 px-4 text-white bg-themeColor hover:bg-themeColor/80 duration-200 overflow-hidden",
							loading &&
								"bg-themeColor/60 hover:bg-themeColor/60 border-themeColor/60"
						)}
						onClick={handleConfirm}
						disabled={loading}
					>
						{yesButtonText}
					</button>
				</div>
			</div>
		</div>
	);
}

export default ConfirmationModal;
